import { State } from '@hookstate/core';
import { IProduct } from '@models/Product.model';
import { Image } from '@mantine/core';
import { ImagePlaceholder } from '@pages/Products/components/ListProducts/ListProducts.styles';
import ProductImage from '@assets/png/product.png';
import React from 'react';
import CloseImage from '@assets/svg/close-btn.svg';
import {
  Container,
  ScrollDiv,
  Label,
  ProductDiv,
  CheckCircle,
  ProductText,
  Header,
  Close,
} from './ShowSelectedFieldsContent.styles';

interface IAddFieldContent {
  openAddField: State<boolean>;
  listOfProducts: IProduct[];
  setListOfProducts: (list: IProduct[]) => void;
}

const ShowSelectedFieldsContent = ({
  openAddField,
  listOfProducts,
  setListOfProducts,
}: IAddFieldContent) => {
  return (
    <Container>
      <Header>
        <Label>Selected Product</Label>
        <Close
          src={CloseImage}
          alt="close"
          onClick={async () => {
            openAddField.set(false);
          }}
        />
      </Header>
      <ScrollDiv>
        {listOfProducts.map(product => {
          return (
            <ProductDiv>
              <CheckCircle
                onClick={() => {
                  const removedProduct = listOfProducts.filter(
                    item => item.id !== product.id,
                  );
                  setListOfProducts(removedProduct);
                }}
              />
              {product.imageUrl ? (
                <Image
                  src={product.imageUrl}
                  alt=""
                  styles={() => ({
                    root: {
                      backgroundColor: 'transparent',
                      border: 'none',
                      borderRadius: '4px',
                    },
                  })}
                  withPlaceholder
                  placeholder={
                    <ImagePlaceholder
                      className="defaultImage"
                      src={ProductImage}
                      alt=""
                    />
                  }
                />
              ) : (
                <ImagePlaceholder
                  className="defaultImage"
                  src={ProductImage}
                  alt="productImages"
                />
              )}
              <ProductText style={{ marginRight: 16, width: '20%' }}>
                {product.model}
              </ProductText>
              <ProductText style={{ marginRight: 16, width: '20%' }}>
                {product.manufacturer.name}
              </ProductText>
              <ProductText style={{ width: '60%' }}>{product.name}</ProductText>
            </ProductDiv>
          );
        })}
      </ScrollDiv>
    </Container>
  );
};

export { ShowSelectedFieldsContent };
